module.exports = __webpack_public_path__ + "static/media/001.2822b78e.jpg";